module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full bgwhite black",
    class: {
      'active': _vm.isActive
    },
    attrs: {
      "data-header": "green",
      "data-type": "layout",
      "id": "problems-graph"
    }
  }, [_c('div', {
    staticClass: "full-inner"
  }, [_c('div', {
    staticClass: "span-table va-top text-left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "content-500"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.consumables.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph-list pt3"
  }, _vm._l((_vm.consumables.stats), function(item) {
    return _c('div', {
      staticClass: "field pb1"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.title) + " " + _vm._s(item.percentage + '%'))]), _vm._v(" "), _c('span', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "filled",
      style: ({
        width: (_vm.isActive ? parseFloat(item.percentage) + '%' : 0 + '%')
      })
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "content-500"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.residuals.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "graph-list pt3"
  }, _vm._l((_vm.residuals.stats), function(item) {
    return _c('div', {
      staticClass: "field pb1"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.title) + " " + _vm._s(item.percentage + '%'))]), _vm._v(" "), _c('span', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "filled",
      style: ({
        width: (_vm.isActive ? item.percentage + '%' : 0 + '%')
      })
    })])])
  }))])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center pt3"
  }, [_vm._v(_vm._s(_vm.credits))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more green",
    attrs: {
      "href": "#",
      "data-index": "3"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eacb35c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Problems-graph.vue
// module id = 170
// module chunks = 1